import styled from 'styled-components'

export const Input = styled.input`
  width: 1em;
  height: 1em;
  border: 1px solid ${({ theme }) => theme.themeColorPale};
  border-radius: 50%;
  background: #fff;
  cursor: pointer;
  margin-right: ${({ theme }) => theme.gutterSmall};
  box-shadow: none !important;
  flex: 0 0 1em;

  &:checked {
    background: ${({ theme }) => theme.themeColorAccent};
    border-color: ${({ theme }) => theme.themeColorPale};
  }
  
  ${({ required, theme }) => required && `
    .under-validation &:invalid {
      border: 2px solid ${theme.themeColorError};
    }

    .under-validation &:valid {
      border: 2px solid ${theme.themeColorAccent};
    }
  `}
`
